export const themeOptions = ['theme1', 'theme2', 'theme3', 'theme4'];
export const themeOptionsOptional = ['', ...themeOptions];
export const phonePositions = ['left', 'center', 'right'];
export const paymentOptions = ['realTime', 'nextDay', 'standard', 'sameDay'];
